/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import Webhook = DealerwareWebServices.Webhook;

    getDealerwareWebComponentsModule()
        .constant(
            'webhookResources', [
                {
                    index       : 0,
                    displayText : 'Vehicles',
                    value       : 'Webhook::Car',
                    options     :
                        [
                            { displayText   : 'Infleet',
                              value         : 'create',
                              trigger       : null
                            },
                            { displayText   : 'Defleet',
                              value         : 'update-disposed',
                              trigger       : 'disposed'
                            }
                        ]
                },
                {
                    index       : 1,
                    displayText : 'Contracts',
                    value       : 'Webhook::Reservation',
                    options     :
                        [
                            { displayText   : 'Booked',
                              value         : 'create',
                              trigger       : null
                            },
                            { displayText   : 'Started',
                              value         : 'update-started',
                              trigger       : 'started'
                            },
                            { displayText   : 'Finished',
                              value         : 'update-finished',
                              trigger       : 'finished'
                            },
                            { displayText   : 'Updated',
                              value         : 'update-updated',
                              trigger       : 'updated'
                            },
                            { displayText   : 'Cancelled',
                              value         : 'update-cancelled',
                              trigger       : 'cancelled'
                            }
                        ]
                }
            ]
        )
        .constant(
            'webHook', {

            }
        );

    export class SettingsWebhooksDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$q',
            '$mdDialog',
            'DealerwareWebhookCollection',
            'DealerwareWebhookFactory',
            '$mobilityCompanyAuthentication',
            '$dealerwareNotification',
            '$dealerwareLoading',
            '$timeout',
            'DataUtils',
            'webhookResources'
        ];

        private dataUtils               : any;

        private webhooks                : Webhook[];
        private webhooksCollection      : any;
        private webhook                 : Webhook = (<Webhook>{ });
        private webhooksForm            : ng.IFormController;
        private webhookSelectedIndex    : number = -1;
        private webhookResourceActions  : any[] = [ ];

        private showWebhookEdit         : string = '';

        private loading                 : boolean = true;
        private loader                  : any;

        private webhookGridColumns      : any[];

        constructor(
            public $scope                   : any,
            public $q                       : any,
            public $mdDialog                : any,
            public WebhookCollection        : any,
            public WebhookFactory           : any,
            public $auth                    : any,
            public $dealerwareNotification  : any,
            public $dealerwareLoading       : any,
            public $timeout                 : any,
            public DataUtils                : any,
            public webhookResources         : any
        ) {
            this.dataUtils = DataUtils.getInstance();
            this.webhook = WebhookFactory.getInstance().initialize({
                url: 'https://'
            });

            this.webhook.location_id = this.$auth.location.id;

            this.loadWebhooks();

            this.webhookGridColumns = [{
                key: 'type',
                header: 'Resource'
            },{
                key: 'action',
                header: 'State'
            }, {
                key: 'url',
                header: 'URL'
            }, {
                key: 'auth_header_name',
                header: 'Header'
            }, {
                key: 'auth_header_value',
                header: 'Value'
            }, {
                key: 'handshake',
                header: 'Handshake',
                renderHtml: false,
                classFn: function(webcook: any) {
                    return { capsule    : true,
                             yes        :   webcook.handshake,
                             no         : ! webcook.handshake
                           };
                },
                dataFilter: function (handshake: any) {
                    return handshake ? 'yes' : 'no';
                },
            }, {
                key: 'enable',
                header: 'enable',
                customColumn: 'enableWebhookCheckbox'
            }, {
                key: 'actions',
                header: 'actions',
                customColumn: 'webhookActionButtons'
            }]
        }

        private showWebhookEditAndFill ( index: number ) : void {

            this.$timeout( ( ) => {
                this.showWebhookEdit = 'edit';
                this.setWebhookResourceActions(this.webhooks[index].type);
                this.webhookSelectedIndex = index;
                this.webhook.fill(this.webhooks[index]);
            });
        }

        private isWebhookEdited () : boolean {

            var isWebhookEdited = false;

            Object.keys(this.webhook).forEach( ( key: string ) => {

                if ( (<any>this.webhook)[key] !== undefined
                     && this.webhook.nonObjectProperties.indexOf(key) === -1
                   ) {

                    // Action selection is a composite of action and trigger, so the comparison
                    // has to include both fields.
                    //
                    if ( key === 'action'
                        && (<any>this.webhook)[key] + this.webhook.defaults.trigger
                        !== this.webhook.defaults[key] + this.webhook.defaults.trigger
                    ) {
                        isWebhookEdited = true;
                    }
                    // Every other webhook field.
                    //
                    else if ((<any>this.webhook)[key] !== this.webhook.defaults[key]) {
                        isWebhookEdited = true;
                    }
                }
            });

            return isWebhookEdited;
        }

        private isSaveWebhookEnabled () : boolean {

            if (! this.webhooksForm.$valid) {
                return false;
            }

            if (this.webhooksForm.$pristine) {
                return false;
            }

            if (! this.isWebhookEdited()) {
                return false;
            }

            return true;
        }

        private isWebhookListItemDisabled () : boolean {
            return this.webhookSelectedIndex !== -1;
        }

        private setWebhookResourceActions (type? : string) : void {

            type = type || this.webhook.type;

            if (type) {
                this.webhookResources.forEach( ( resource: any ) => {
                    if (type === resource.value) {

                        this.webhookResourceActions = [ ];

                        // These machinations to delay and then redigest seem to be necessary to
                        // prevent md-select from remembering the default selected item from previous
                        // repopulations.
                        //
                        // A half-second delay is really pretty terrible UX wise, but 300 ms consistently
                        // fails, and allows, for instance, 'Infleet, Booked' to appear as the selected
                        // state to appear based on certain editing actions.
                        //
                        this.$timeout( ( ) => {
                            this.$scope.$apply( ( ) => {
                                this.webhookResourceActions = angular.copy(resource.options);
                            })
                        }, 500);
                    }
                });
            }
        }

        private setWebhookTrigger () : void {

            this.webhookResourceActions.forEach( ( action: any ) => {

                var webhookActionString = this.dataUtils.isBlank(this.webhook.trigger) ?
                    this.webhook.action : `${this.webhook.action}-${this.webhook.trigger}`;

                if (webhookActionString === action.value) {
                    this.webhook.trigger = action.trigger;
                }
            });
        }

        private clearWebhook () : void {

            this.showWebhookEdit = '';

            this.webhook.clear();
            this.webhookSelectedIndex = -1;

            Object.keys(this.webhook).forEach( ( key: string ) => {
                if ( this.webhook.nonObjectProperties.indexOf(key) === -1
                    && this.webhooksForm[key]
                ) {
                    this.webhooksForm[key].$setPristine();
                    this.webhooksForm[key].$setUntouched();
                }
            });

            this.webhooksForm.$setPristine();
        }

        private processWebhookResults() : void {
            this.webhooks = this.webhooksCollection.data;
            this.clearWebhook();
            this.loader.close();
        }

        private loadWebhooks () : ng.IPromise<void> {

            this.loading = true;

            var deferred = this.$q.defer();

            this.WebhookCollection.index({
                params: {
                    location_id: this.$auth.location.id
                },
                promise: true
            })
                .then( ( response: any ) => {
                    this.webhooks = response.data;
                    this.webhooksCollection = angular.copy(response);
                    if (! this.webhooks.length) {
                        this.showWebhookEdit = 'create';
                    }
                    deferred.resolve();
                })
                .catch( ( ) => {
                    deferred.reject();
                })
                .finally( ( ) => {
                    this.loading = false;
                });

            return deferred;
        }

        private deleteWebhook (index: number) : void {

            var confirmationText = 'Are you sure you\'d like to delete this webhook?';

            var confirm = this.$mdDialog.confirm()
                .textContent(confirmationText)
                .ariaLabel(confirmationText)
                .ok('Delete')
                .cancel('Cancel');

            this.$mdDialog.show(confirm)
                .then(() => {

                    this.loading = true;

                    this.webhook.delete(
                        this.webhooks[index].location_id, this.webhooks[index].id
                    )
                        .then( ( ) => {
                            this.clearWebhook();
                            return this.loadWebhooks();
                        });
                });
        }

        public enableWebhook ( event: JQueryEventObject, inlineEditIndex: number ) : void {

            this.webhooks[inlineEditIndex].active = ! this.webhooks[inlineEditIndex].active;
            this.saveWebhook (inlineEditIndex);
        }

        private saveWebhook ( inlineEditIndex?: number ) : void {

            var confirmationText = 'Are you sure you\'d like to save these changes?';

            var isInlineEdit = typeof inlineEditIndex === 'number';
            if (! this.webhook.location_id) {
                this.webhook.location_id = this.$auth.location.id;
            }

            this.$timeout( ( ) => {
                var confirm = this.$mdDialog.confirm()
                    .textContent(confirmationText)
                    .ariaLabel(confirmationText)
                    .ok('Save')
                    .cancel('Cancel');

                (isInlineEdit ? this.$q.when() : this.$mdDialog.show(confirm))
                    .then(() => {

                        this.loading = true;

                        var methodObject = isInlineEdit ? this.webhooks[inlineEditIndex] : this.webhook;

                        methodObject.save()
                            .then( ( ) => {
                                this.clearWebhook();
                                return this.loadWebhooks();
                            })
                            .catch( ( response : any ) => {
                                if (response.data && response.data.message) {
                                        response.data.message = response.data.message
                                        .replace('Trigger must be unique per location and action',
                                            `A webhook for ${this.webhook.getTypeDisplay(this.webhook.type)}
                                            /${this.webhook.getActionDisplay (
                                                this.webhook.type, this.webhook.action, this.webhook.trigger
                                            )} already exists.`
                                        )
                                        .replace('Url', 'URL');
                                }

                                this.loading = false;
                                this.$dealerwareNotification.apiError(response, '');
                            });
                    });
            });
        }

        public pageTransitionError(response: any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public calculateWebhookRowClass ( webhook: Webhook, index: number ) : any {

            var isSelected: boolean = false;

            (<any>this.webhooks).find( ( ) => {
                if (this.webhookSelectedIndex > -1 && this.webhookSelectedIndex === webhook.index) {

                    // The loop is just being used for the side-effect of setting this variable,
                    // but using .find allows for early break unlike forEach.
                    //
                    return isSelected = true;
                }
            });

            return { selected       : isSelected,
                     'not-selected' : this.webhookSelectedIndex > -1 && ! isSelected
                   };
        }
    }


    getDealerwareWebComponentsModule().controller(
        'SettingsWebhooksDirectiveController',
        SettingsWebhooksDirectiveController
    );

    export class SettingsWebhooksDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'SettingsWebhooksDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/settings/webhooks/directive.html';
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareSettingsWebhooks',
        ( ) => new SettingsWebhooksDirective()
    );

}
